module.exports = __webpack_public_path__ + "img/menu-icon-close.bd685524.svg";